import axios from "axios";

export const state = {
    reportworkloadbyuser: [],
};

export const getters = {
    reportworkloadbyuser: state => state.reportworkloadbyuser,
};

export const mutations = {
    setReportWorkloadbyUser(reportworkloadbyuser, newValue) { state.reportworkloadbyuser = newValue},
};

export const actions = {
    fetchReportWorkloadbyUser({ commit }) {
        axios.get('/reportworkloadbyuser').then(res => {
            commit('setReportWorkloadbyUser', res.data.workloads)
        })
    },
    filterReportWorkloadbyUser({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportworkloadbyuser";
        axios.post(url, formData).then((response) => {
            commit('setReportWorkloadbyUser', response.data.workloads)
        })
    },
};
